export const PET = 'pet-insure';
export const HOME = 'home-insure';
export const LIFE = 'life-insure';
export const SMARTLIFE = 'smartlife';
